import * as React from 'react';
import { Link } from 'react-router-dom';
import { Result } from 'antd';

import Button from '../../components/button';

const NonAuthorizedPage: React.FC = () => (
  <Result
    status="403"
    title="403"
    subTitle="Sorry, you are not authorized to access this page."
    extra={
      <Link to="/">
        <Button styleType="primary">Back Home</Button>
      </Link>
    }
  />
);
export default NonAuthorizedPage;
